import React, { useEffect } from "react";
import { Route } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const HomeLayout = ({ component: Component, ...rest }) =>
{
  useEffect(() =>
  {
    document.body.classList.add('home');
    document.body.classList.remove('blog');
  }, [])
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <div className="home">
          <Header />
          <TransitionGroup>
            <CSSTransition key={matchProps.location.key} classNames="fade" timeout={300}>
              <Component {...matchProps} />
            </CSSTransition>
          </TransitionGroup>
          <Footer />
        </div>
      )}
    />
  );
};

export default HomeLayout;
